import { INITIALAIZE_REQUEST, SLUG_SUCCESS, PUT_SUCCESS, INITIALAIZE_FAILURE } from './types';
import baseUrl from '../url'

const normalizeHomepageVariant = (value) => {
    if (!value) return null;
    const v = String(value).trim();
    return (v === 'control' || v === 'ux') ? v : null;
}

const getHomepageVariant = (params) => {
    const fromParams = params?.hv || params?.homepage_variant || params?.homepageVariant;
    const normalizedParam = normalizeHomepageVariant(fromParams);
    if (normalizedParam) return normalizedParam;

    const cookieMatch = document?.cookie?.match(/(?:^|; )kadro_homepage_variant_raw=([^;]+)/);
    if (cookieMatch && cookieMatch[1]) {
        return normalizeHomepageVariant(decodeURIComponent(cookieMatch[1]));
    }

    return null;
}

const initializeRequest = () => {
    return {
        type: INITIALAIZE_REQUEST
    }
}

const slugSuccess = data => {
    return {
        type: SLUG_SUCCESS,
        payload: data,
    }
}
const putSuccess = data => {
    return {
        type: PUT_SUCCESS,
        payload: data,
    }
}

const initializeFailure = error => {
    return {
        type: INITIALAIZE_FAILURE,
        payload: error,
    }
}

//Post to get slug of a new project
export const postData = (search) => {
        return (dispatch) => {
                dispatch(initializeRequest());
                let body = {};
                const qr = {};
                const urlParams = new URLSearchParams(search);
                const params = Object.fromEntries(urlParams);
                // console.log("Params: ", params);
                // [ utm_source, utm_medium, utm_term, utm_content, utm_campaign ]
                if (params.utm_source) {
                    qr.utm_source = params.utm_source;
                }
                if (params.utm_medium) {
                    qr.utm_medium = params.utm_medium;
                }
                if (params.utm_term) {
                    qr.utm_term = params.utm_term;
                }
                if (params.utm_content) {
                    qr.utm_content = params.utm_content;
                }
                if (params.utm_campaign) {
                    qr.utm_campaign = params.utm_campaign;
                }

                const homepageVariant = getHomepageVariant(params);
                if (homepageVariant) {
                    qr.hv = homepageVariant;
                }

                if (Object.keys(search).length !== 0) {
                    body.new = true
                }
                const queries = new URLSearchParams(qr).toString();
                // console.log("Project Action: ", queries);
                const token = localStorage.getItem('token');
                const headers = {
                    Authorization: `Bearer ${token}`,
                    'Content-Type': 'application/json',
                    ...(homepageVariant ? { 'X-Homepage-Variant': homepageVariant } : {})
                };
                fetch(`${baseUrl}/projects${queries !== "" ? `?${queries}` : ``}`, {
            method: 'POST',
            headers,
            body: JSON.stringify(body)
        })
            .then(response => response.json())
            .then((response) => {
                dispatch(slugSuccess(response.slug));
                dispatch(getData(response.slug, search));
            })
            .catch((error) => {
                dispatch(initializeFailure(error.message));
            })
    }
}


export const getData = (slug, search) => {
    return (dispatch) => {
        dispatch(slugSuccess(slug));
        dispatch(initializeRequest());
        const token = localStorage.getItem('token');
        fetch(`${baseUrl}/projects/${slug}`, {
            method: 'GET',
            headers: {
                Authorization: `Bearer ${token}`
            }
        })
            .then(response => response.json())
            .then((response) => {
                // dispatch(putSuccess(response));
                if (response.step !== "thanks") {
                    if (Object.keys(search).length !== 0) {
                        let data = { ...response, ...search };
                        dispatch(putData(slug, data));
                    } else {
                        dispatch(putSuccess(response));
                    }
                } else {
                    let path = location.protocol + '//' + location.host
                    window.location.replace(path + `/projects/${slug}/thank_you`);
                }
            })
            .catch((error) => {
                dispatch(initializeFailure(error.message));
            })
    }
}

//Update steps of project
export const putData = (slug, data) => {
    return (dispatch) => {
        dispatch(initializeRequest());
        const token = localStorage.getItem('token');
        fetch(`${baseUrl}/projects/${slug}`, {
            method: 'PUT',
            headers: {
                Authorization: `Bearer ${token}`,
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(data)
        })
            .then(response => response.json())
            .then((response) => {
                dispatch(putSuccess(response));
            })
            .catch((error) => {
                dispatch(initializeFailure(error.message));
            })
    }
}